<template>
    <b-container fluid>
        <b-row row wrap>
            <b-col cols="12" md="6" v-show="isFill && !isClientUser">
                <app-autocomplete
                    :items="clients"
                    v-model="theClient"
                    label="Cliente"
                    @change="onClientChange"
                ></app-autocomplete>
                <div class="field-error" v-if="!isClientUser && $v.theClient && $v.theClient.$error">
                    Debe seleccionar el cliente
                </div>
            </b-col>
            <b-col cols="12" md="6" v-show="isFill">
                <app-autocomplete
                    :items="venues"
                    v-model="venue"
                    label="Sede"
                    @change="$v.venue.$touch()"
                ></app-autocomplete>
                <div class="field-error" v-if="$v.venue.$error">
                    Debe seleccionar la sede donde se llevará a cabo la ronda
                </div>
            </b-col>
            <b-col cols="12" md="6">
                <app-form-select-input
                    v-model="round.serviceSpotId"
                    label="Puesto"
                    :options="serviceSpotsRounds"
                    :has-error="$v.round.serviceSpotId.$error"
                    error-message="Debe seleccionar el puesto"
                    @change="$v.round.serviceSpotId.$touch()"
                ></app-form-select-input>
                <b-alert
                    show
                    variant="warning"
                    v-if="spotsLoaded && serviceSpotsRounds.length === 0"
                >
                    Debe configurar un puesto de trabajo de tipo ronda para esta
                    sede del cliente
                </b-alert>
            </b-col>
            <b-col cols="12" md="6">
                <app-form-text-input
                    label="Nombre Ronda"
                    v-model="round.name"
                    :has-error="$v.round.name.$error"
                    @input="$v.round.name.$touch()"
                    error-message="Debe escribir el nombre de la ronda"
                />
            </b-col>
            <b-col cols="12" md="6">
                <app-form-time-input
                    label="Duración (Horas)"
                    v-model="round.duration"
                    step="0.5"
                    :required="true"
                    :has-error="$v.round.duration.$error"
                    error-message="Debe seleccionar la duración de la ronda"
                    @input="$v.round.duration.$touch()"
                ></app-form-time-input>
            </b-col>
        </b-row>
        <b-row row wrap>
            <b-col cols="12" class="mt-1">
                <app-sub-title text="Días de Operación"></app-sub-title>
            </b-col>
            <b-col cols="12" class="mt-2">
                <b-form-checkbox-group label="Días de la ronda">
                    <b-checkbox
                        v-for="d in days"
                        :key="d.value"
                        :value="d.value"
                        v-model="round.days"
                        >{{ d.name }}</b-checkbox
                    >
                </b-form-checkbox-group>
            </b-col>
            <b-col cols="12" class="mt-3">
                <app-sub-title text="Franja de Operación"></app-sub-title>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-input
                    type="time"
                    v-model="round.startHour"
                    @change="$v.round.startHour.$touch()"
                ></b-form-input>
                <div class="field-error" v-if="$v.round.startHour.$error">
                    Debe seleccionar la hora de inicio
                </div>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-input
                    type="time"
                    v-model="round.endHour"
                    @change="$v.round.endHour.$touch()"
                ></b-form-input>
                <div class="field-error" v-if="$v.round.endHour.$error">
                    Debe seleccionar la hora de finalización
                </div>
            </b-col>
        </b-row>
        <b-row row wrap class="mt-3">
            <!-- <b-col cols="12" md="6">
                <app-round-config-form-control-points
                    v-model="round.controlPoints"
                />
            </b-col> -->
            <b-col cols="12" v-show="checkListDays">
                <app-round-config-form-check-list
                    v-model="round.checkList"
                    ref="checkListItems"
                ></app-round-config-form-check-list>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import Autocomplete from "@components/UI/Controls/AutocompleteV2/Autocomplete";
import venuesRespository from "@repositories/venues.repository";
import RoundConfigFormControlPoints from "./RoundConfigFormControlPoints/RoundConfigFormControlPoints";
import RoundConfigFormCheckList from "./RoundConfigFormCheckList/RoundConfigFormCheckList";
import roundsRepository from "@repositories/rounds.repository";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import serviceSpotRepository from "@repositories/serviceSpot.repository";

export default {
    components: {
        appAutocomplete: Autocomplete,
        appRoundConfigFormControlPoints: RoundConfigFormControlPoints,
        appRoundConfigFormCheckList: RoundConfigFormCheckList
    },
    props: {
        theRound: {
            type: Object,
            default: null
        }
    },
    data: () => ({
        round: {
            clientId: "",
            name: "",
            startHour: "",
            endHour: "",
            days: "",
            venueId: "",
            controlPoints: [],
            checkList: [],
            duration: "1",
            serviceSpotId: "" // puesto de trabajo = structura de tipo access point ronda
        },
        venue: "",
        days,
        venues: [],
        theClient: "",
        serviceSpots: [],
        spotsLoaded: false,
        isFill: true,
        checkListDays: true,
        roundId: ""
    }),
    validations: {
        round: {
            name: { required },
            startHour: { required },
            endHour: { required },
            duration: { required },
            serviceSpotId: { required }
        },
        venue: { required },
        theClient: { required }
    },
    watch: {
        venue(val) {
            this.round.venueId = !!val ? val.id : "";
            this.loadServiceSpots();
        },
        theClient(client) {
            this.round.clientId = !!client ? client.id : "";
            if (!!client) this.loadVenues();
            else this.venues = [];
        }
    },
    computed: {
        ...mapGetters(["clients", "client"]),
        editing() {
            return !!this.theRound;
        },
        isClientUser() {
            return this.user.profile.slug === 'cliente-admin' || 
                   this.user.profile.client_side === true;
        },
        serviceSpotsRounds() {
            return this.serviceSpots.filter(
                item => item.service_spot_type.slug === "ronda"
            );
        }
    },
    methods: {
        onClientChange() {
            if (this.$v && this.$v.theClient) {
                this.$v.theClient.$touch();
            }
        },
        fill(round) {
            this.roundId = round.id;
            this.isFill = false;
            this.checkListDays = false;
            this.round.venueId = round.venue_id;
            this.loadServiceSpots();
            this.round.serviceSpotId = round.service_spot_id;
            this.round.name = round.name;
            this.round.duration = round.duration;
            this.round.days = [];
            round.days.map(d => this.round.days.push(d.day));
            this.round.startHour = round.start_hour;
            this.round.endHour = round.end_hour;
            this.round.clientId = round.client_id;
            this.$v.$touch();
        },
        reset() {
            try {
                // Verificar que $v esté disponible antes de resetear
                if (this.$v && typeof this.$v.$reset === 'function') {
                    this.$v.$reset();
                }
                
                this.roundId = "";
                this.round.duration = "";
                this.round.name = "";
                this.round.startHour = "00:00";
                this.round.endHour = "23:59";
                this.round.days = [];
                this.round.controlPoints = [];
                this.round.checkList = [];
                this.round.serviceSpotId = "";
                
                if (this.isClientUser && this.client) {
                    this.round.clientId = this.client.id;
                    this.theClient = this.client;
                    // Usar $nextTick para asegurar que loadVenues se ejecute después
                    this.$nextTick(() => {
                        if (this.loadVenues) {
                            this.loadVenues();
                        }
                    });
                } else {
                    this.theClient = "";
                }
                
                this.venue = "";
                this.isFill = true;
                this.checkListDays = true;
                
                // Inicializar días
                if (this.days && Array.isArray(this.days)) {
                    this.days.map(d => this.round.days.push(d.value));
                }
                
                // Usar $nextTick para asegurar que el componente esté montado
                this.$nextTick(() => {
                    if (this.$refs && this.$refs.checkListItems && typeof this.$refs.checkListItems.reset === 'function') {
                        this.$refs.checkListItems.reset();
                    }
                });
            } catch (error) {
                console.error('Error en reset():', error);
            }
        },
        async loadVenues() {
            const vr = { ...venuesRespository };

            try {
                const data = await vr.loadVenuesByClient(this.theClient.id);
                this.venues = data;
            } catch (err) {
                toastr.error(
                    `Ocurrió un error al cargar las sedes [${err.message}]`
                );
            }
        },
        async save() {
            if (this.roundId === "") {
                // Solo validar theClient si no es usuario cliente
                if (!this.isClientUser && this.$v.theClient) {
                    this.$v.theClient.$touch();
                }
                this.$v.$touch();
                
                // Verificar validación excluyendo theClient si es usuario cliente
                let isValid = true;
                if (this.isClientUser) {
                    isValid = this.$v.round.$invalid === false && 
                             this.$v.venue.$invalid === false;
                } else {
                    isValid = !this.$v.$invalid;
                }
                
                if (!isValid)
                    return toastr.error(
                        "Debe diligenciar los campos obligatorios"
                    );
            }
            if (this.round.days.length === 0)
                return toastr.warning(
                    "Se debe seleccionar al menos un día para realizar la ronda"
                );

            try {
                const payload = {
                    ...this.round,
                    userId: this.user.id,
                    clientId: this.round.clientId
                };

                const { data } = !this.roundId
                    ? await repo.post("rounds", payload)
                    : await repo.put(`rounds/${this.roundId}`, payload);

                if (data.status) {
                    toastr.success(data.msg);
                    this.$emit("onSave", data.round);
                } else {
                    toastr.error(data.msg);
                    this.$emit("onError");
                }
            } catch (err) {
                toastr.error(
                    `Ocurrió un error al guardar la ronda [${err.message}]`
                );
            }
        },
        async loadServiceSpots() {
            const sr = { ...serviceSpotRepository };
            const { data } = await sr.get({ venue: this.round.venueId });
            this.serviceSpots = data;
            this.spotsLoaded = true;
        }
    },
    mounted() {
        // No llamar reset() aquí porque el modal puede no estar visible aún
        // Se llamará cuando se abra el modal desde openForm()
        this.load("clients");
    }
};
const days = [
    { name: "L", value: 1 },
    { name: "M", value: 2 },
    { name: "M", value: 3 },
    { name: "J", value: 4 },
    { name: "V", value: 5 },
    { name: "S", value: 6 },
    { name: "D", value: 0 }
];
</script>
